
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $d486cd8337e91fbc$exports = {};
(function(global, factory) {
    $d486cd8337e91fbc$exports = factory();
})($d486cd8337e91fbc$exports, function() {
    'use strict';
    /*!
   * mustache.js - Logic-less {{mustache}} templates with JavaScript
   * http://github.com/janl/mustache.js
   */ var objectToString = Object.prototype.toString;
    var isArray = Array.isArray || function isArrayPolyfill(object) {
        return objectToString.call(object) === '[object Array]';
    };
    function isFunction(object) {
        return typeof object === 'function';
    }
    /**
   * More correct typeof string handling array
   * which normally returns typeof 'object'
   */ function typeStr(obj) {
        return isArray(obj) ? 'array' : typeof obj;
    }
    function escapeRegExp(string) {
        return string.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&');
    }
    /**
   * Null safe way of checking whether or not an object,
   * including its prototype, has a given property
   */ function hasProperty(obj, propName) {
        return obj != null && typeof obj === 'object' && propName in obj;
    }
    /**
   * Safe way of detecting whether or not the given thing is a primitive and
   * whether it has the given property
   */ function primitiveHasOwnProperty(primitive, propName) {
        return primitive != null && typeof primitive !== 'object' && primitive.hasOwnProperty && primitive.hasOwnProperty(propName);
    }
    // Workaround for https://issues.apache.org/jira/browse/COUCHDB-577
    // See https://github.com/janl/mustache.js/issues/189
    var regExpTest = RegExp.prototype.test;
    function testRegExp(re, string) {
        return regExpTest.call(re, string);
    }
    var nonSpaceRe = /\S/;
    function isWhitespace(string) {
        return !testRegExp(nonSpaceRe, string);
    }
    var entityMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
    };
    function escapeHtml(string) {
        return String(string).replace(/[&<>"'`=\/]/g, function fromEntityMap(s) {
            return entityMap[s];
        });
    }
    var whiteRe = /\s*/;
    var spaceRe = /\s+/;
    var equalsRe = /\s*=/;
    var curlyRe = /\s*\}/;
    var tagRe = /#|\^|\/|>|\{|&|=|!/;
    /**
   * Breaks up the given `template` string into a tree of tokens. If the `tags`
   * argument is given here it must be an array with two string values: the
   * opening and closing tags used in the template (e.g. [ "<%", "%>" ]). Of
   * course, the default is to use mustaches (i.e. mustache.tags).
   *
   * A token is an array with at least 4 elements. The first element is the
   * mustache symbol that was used inside the tag, e.g. "#" or "&". If the tag
   * did not contain a symbol (i.e. {{myValue}}) this element is "name". For
   * all text that appears outside a symbol this element is "text".
   *
   * The second element of a token is its "value". For mustache tags this is
   * whatever else was inside the tag besides the opening symbol. For text tokens
   * this is the text itself.
   *
   * The third and fourth elements of the token are the start and end indices,
   * respectively, of the token in the original template.
   *
   * Tokens that are the root node of a subtree contain two more elements: 1) an
   * array of tokens in the subtree and 2) the index in the original template at
   * which the closing tag for that section begins.
   *
   * Tokens for partials also contain two more elements: 1) a string value of
   * indendation prior to that tag and 2) the index of that tag on that line -
   * eg a value of 2 indicates the partial is the third tag on this line.
   */ function parseTemplate(template, tags) {
        if (!template) return [];
        var lineHasNonSpace = false;
        var sections = []; // Stack to hold section tokens
        var tokens = []; // Buffer to hold the tokens
        var spaces = []; // Indices of whitespace tokens on the current line
        var hasTag = false; // Is there a {{tag}} on the current line?
        var nonSpace = false; // Is there a non-space char on the current line?
        var indentation = ''; // Tracks indentation for tags that use it
        var tagIndex = 0; // Stores a count of number of tags encountered on a line
        // Strips all whitespace tokens array for the current line
        // if there was a {{#tag}} on it and otherwise only space.
        function stripSpace() {
            if (hasTag && !nonSpace) while(spaces.length)delete tokens[spaces.pop()];
            else spaces = [];
            hasTag = false;
            nonSpace = false;
        }
        var openingTagRe, closingTagRe, closingCurlyRe;
        function compileTags(tagsToCompile) {
            if (typeof tagsToCompile === 'string') tagsToCompile = tagsToCompile.split(spaceRe, 2);
            if (!isArray(tagsToCompile) || tagsToCompile.length !== 2) throw new Error('Invalid tags: ' + tagsToCompile);
            openingTagRe = new RegExp(escapeRegExp(tagsToCompile[0]) + '\\s*');
            closingTagRe = new RegExp('\\s*' + escapeRegExp(tagsToCompile[1]));
            closingCurlyRe = new RegExp('\\s*' + escapeRegExp('}' + tagsToCompile[1]));
        }
        compileTags(tags || mustache.tags);
        var scanner = new Scanner(template);
        var start, type, value, chr, token, openSection;
        while(!scanner.eos()){
            start = scanner.pos;
            // Match any text between tags.
            value = scanner.scanUntil(openingTagRe);
            if (value) for(var i = 0, valueLength = value.length; i < valueLength; ++i){
                chr = value.charAt(i);
                if (isWhitespace(chr)) {
                    spaces.push(tokens.length);
                    indentation += chr;
                } else {
                    nonSpace = true;
                    lineHasNonSpace = true;
                    indentation += ' ';
                }
                tokens.push([
                    'text',
                    chr,
                    start,
                    start + 1
                ]);
                start += 1;
                // Check for whitespace on the current line.
                if (chr === '\n') {
                    stripSpace();
                    indentation = '';
                    tagIndex = 0;
                    lineHasNonSpace = false;
                }
            }
            // Match the opening tag.
            if (!scanner.scan(openingTagRe)) break;
            hasTag = true;
            // Get the tag type.
            type = scanner.scan(tagRe) || 'name';
            scanner.scan(whiteRe);
            // Get the tag value.
            if (type === '=') {
                value = scanner.scanUntil(equalsRe);
                scanner.scan(equalsRe);
                scanner.scanUntil(closingTagRe);
            } else if (type === '{') {
                value = scanner.scanUntil(closingCurlyRe);
                scanner.scan(curlyRe);
                scanner.scanUntil(closingTagRe);
                type = '&';
            } else value = scanner.scanUntil(closingTagRe);
            // Match the closing tag.
            if (!scanner.scan(closingTagRe)) throw new Error('Unclosed tag at ' + scanner.pos);
            if (type == '>') token = [
                type,
                value,
                start,
                scanner.pos,
                indentation,
                tagIndex,
                lineHasNonSpace
            ];
            else token = [
                type,
                value,
                start,
                scanner.pos
            ];
            tagIndex++;
            tokens.push(token);
            if (type === '#' || type === '^') sections.push(token);
            else if (type === '/') {
                // Check section nesting.
                openSection = sections.pop();
                if (!openSection) throw new Error('Unopened section "' + value + '" at ' + start);
                if (openSection[1] !== value) throw new Error('Unclosed section "' + openSection[1] + '" at ' + start);
            } else if (type === 'name' || type === '{' || type === '&') nonSpace = true;
            else if (type === '=') // Set the tags for the next time around.
            compileTags(value);
        }
        stripSpace();
        // Make sure there are no open sections when we're done.
        openSection = sections.pop();
        if (openSection) throw new Error('Unclosed section "' + openSection[1] + '" at ' + scanner.pos);
        return nestTokens(squashTokens(tokens));
    }
    /**
   * Combines the values of consecutive text tokens in the given `tokens` array
   * to a single token.
   */ function squashTokens(tokens) {
        var squashedTokens = [];
        var token, lastToken;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            if (token) {
                if (token[0] === 'text' && lastToken && lastToken[0] === 'text') {
                    lastToken[1] += token[1];
                    lastToken[3] = token[3];
                } else {
                    squashedTokens.push(token);
                    lastToken = token;
                }
            }
        }
        return squashedTokens;
    }
    /**
   * Forms the given array of `tokens` into a nested tree structure where
   * tokens that represent a section have two additional items: 1) an array of
   * all tokens that appear in that section and 2) the index in the original
   * template that represents the end of that section.
   */ function nestTokens(tokens) {
        var nestedTokens = [];
        var collector = nestedTokens;
        var sections = [];
        var token, section;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            token = tokens[i];
            switch(token[0]){
                case '#':
                case '^':
                    collector.push(token);
                    sections.push(token);
                    collector = token[4] = [];
                    break;
                case '/':
                    section = sections.pop();
                    section[5] = token[2];
                    collector = sections.length > 0 ? sections[sections.length - 1][4] : nestedTokens;
                    break;
                default:
                    collector.push(token);
            }
        }
        return nestedTokens;
    }
    /**
   * A simple string scanner that is used by the template parser to find
   * tokens in template strings.
   */ function Scanner(string) {
        this.string = string;
        this.tail = string;
        this.pos = 0;
    }
    /**
   * Returns `true` if the tail is empty (end of string).
   */ Scanner.prototype.eos = function eos() {
        return this.tail === '';
    };
    /**
   * Tries to match the given regular expression at the current position.
   * Returns the matched text if it can match, the empty string otherwise.
   */ Scanner.prototype.scan = function scan(re) {
        var match = this.tail.match(re);
        if (!match || match.index !== 0) return '';
        var string = match[0];
        this.tail = this.tail.substring(string.length);
        this.pos += string.length;
        return string;
    };
    /**
   * Skips all text until the given regular expression can be matched. Returns
   * the skipped string, which is the entire tail if no match can be made.
   */ Scanner.prototype.scanUntil = function scanUntil(re) {
        var index = this.tail.search(re), match;
        switch(index){
            case -1:
                match = this.tail;
                this.tail = '';
                break;
            case 0:
                match = '';
                break;
            default:
                match = this.tail.substring(0, index);
                this.tail = this.tail.substring(index);
        }
        this.pos += match.length;
        return match;
    };
    /**
   * Represents a rendering context by wrapping a view object and
   * maintaining a reference to the parent context.
   */ function Context(view, parentContext) {
        this.view = view;
        this.cache = {
            '.': this.view
        };
        this.parent = parentContext;
    }
    /**
   * Creates a new context using the given view with this context
   * as the parent.
   */ Context.prototype.push = function push(view) {
        return new Context(view, this);
    };
    /**
   * Returns the value of the given name in this context, traversing
   * up the context hierarchy if the value is absent in this context's view.
   */ Context.prototype.lookup = function lookup(name) {
        var cache1 = this.cache;
        var value;
        if (cache1.hasOwnProperty(name)) value = cache1[name];
        else {
            var context = this, intermediateValue, names, index, lookupHit = false;
            while(context){
                if (name.indexOf('.') > 0) {
                    intermediateValue = context.view;
                    names = name.split('.');
                    index = 0;
                    /**
           * Using the dot notion path in `name`, we descend through the
           * nested objects.
           *
           * To be certain that the lookup has been successful, we have to
           * check if the last object in the path actually has the property
           * we are looking for. We store the result in `lookupHit`.
           *
           * This is specially necessary for when the value has been set to
           * `undefined` and we want to avoid looking up parent contexts.
           *
           * In the case where dot notation is used, we consider the lookup
           * to be successful even if the last "object" in the path is
           * not actually an object but a primitive (e.g., a string, or an
           * integer), because it is sometimes useful to access a property
           * of an autoboxed primitive, such as the length of a string.
           **/ while(intermediateValue != null && index < names.length){
                        if (index === names.length - 1) lookupHit = hasProperty(intermediateValue, names[index]) || primitiveHasOwnProperty(intermediateValue, names[index]);
                        intermediateValue = intermediateValue[names[index++]];
                    }
                } else {
                    intermediateValue = context.view[name];
                    /**
           * Only checking against `hasProperty`, which always returns `false` if
           * `context.view` is not an object. Deliberately omitting the check
           * against `primitiveHasOwnProperty` if dot notation is not used.
           *
           * Consider this example:
           * ```
           * Mustache.render("The length of a football field is {{#length}}{{length}}{{/length}}.", {length: "100 yards"})
           * ```
           *
           * If we were to check also against `primitiveHasOwnProperty`, as we do
           * in the dot notation case, then render call would return:
           *
           * "The length of a football field is 9."
           *
           * rather than the expected:
           *
           * "The length of a football field is 100 yards."
           **/ lookupHit = hasProperty(context.view, name);
                }
                if (lookupHit) {
                    value = intermediateValue;
                    break;
                }
                context = context.parent;
            }
            cache1[name] = value;
        }
        if (isFunction(value)) value = value.call(this.view);
        return value;
    };
    /**
   * A Writer knows how to take a stream of tokens and render them to a
   * string, given a context. It also maintains a cache of templates to
   * avoid the need to parse the same template twice.
   */ function Writer() {
        this.templateCache = {
            _cache: {},
            set: function set(key, value) {
                this._cache[key] = value;
            },
            get: function get(key) {
                return this._cache[key];
            },
            clear: function clear() {
                this._cache = {};
            }
        };
    }
    /**
   * Clears all cached templates in this writer.
   */ Writer.prototype.clearCache = function clearCache() {
        if (typeof this.templateCache !== 'undefined') this.templateCache.clear();
    };
    /**
   * Parses and caches the given `template` according to the given `tags` or
   * `mustache.tags` if `tags` is omitted,  and returns the array of tokens
   * that is generated from the parse.
   */ Writer.prototype.parse = function parse(template, tags) {
        var cache1 = this.templateCache;
        var cacheKey = template + ':' + (tags || mustache.tags).join(':');
        var isCacheEnabled = typeof cache1 !== 'undefined';
        var tokens = isCacheEnabled ? cache1.get(cacheKey) : undefined;
        if (tokens == undefined) {
            tokens = parseTemplate(template, tags);
            isCacheEnabled && cache1.set(cacheKey, tokens);
        }
        return tokens;
    };
    /**
   * High-level method that is used to render the given `template` with
   * the given `view`.
   *
   * The optional `partials` argument may be an object that contains the
   * names and templates of partials that are used in the template. It may
   * also be a function that is used to load partial templates on the fly
   * that takes a single argument: the name of the partial.
   *
   * If the optional `config` argument is given here, then it should be an
   * object with a `tags` attribute or an `escape` attribute or both.
   * If an array is passed, then it will be interpreted the same way as
   * a `tags` attribute on a `config` object.
   *
   * The `tags` attribute of a `config` object must be an array with two
   * string values: the opening and closing tags used in the template (e.g.
   * [ "<%", "%>" ]). The default is to mustache.tags.
   *
   * The `escape` attribute of a `config` object must be a function which
   * accepts a string as input and outputs a safely escaped string.
   * If an `escape` function is not provided, then an HTML-safe string
   * escaping function is used as the default.
   */ Writer.prototype.render = function render(template, view, partials, config) {
        var tags = this.getConfigTags(config);
        var tokens = this.parse(template, tags);
        var context = view instanceof Context ? view : new Context(view, undefined);
        return this.renderTokens(tokens, context, partials, template, config);
    };
    /**
   * Low-level method that renders the given array of `tokens` using
   * the given `context` and `partials`.
   *
   * Note: The `originalTemplate` is only ever used to extract the portion
   * of the original template that was contained in a higher-order section.
   * If the template doesn't use higher-order sections, this argument may
   * be omitted.
   */ Writer.prototype.renderTokens = function renderTokens(tokens, context, partials, originalTemplate, config) {
        var buffer = '';
        var token, symbol, value;
        for(var i = 0, numTokens = tokens.length; i < numTokens; ++i){
            value = undefined;
            token = tokens[i];
            symbol = token[0];
            if (symbol === '#') value = this.renderSection(token, context, partials, originalTemplate, config);
            else if (symbol === '^') value = this.renderInverted(token, context, partials, originalTemplate, config);
            else if (symbol === '>') value = this.renderPartial(token, context, partials, config);
            else if (symbol === '&') value = this.unescapedValue(token, context);
            else if (symbol === 'name') value = this.escapedValue(token, context, config);
            else if (symbol === 'text') value = this.rawValue(token);
            if (value !== undefined) buffer += value;
        }
        return buffer;
    };
    Writer.prototype.renderSection = function renderSection(token, context, partials, originalTemplate, config) {
        var self = this;
        var buffer = '';
        var value = context.lookup(token[1]);
        // This function is used to render an arbitrary template
        // in the current context by higher-order sections.
        function subRender(template) {
            return self.render(template, context, partials, config);
        }
        if (!value) return;
        if (isArray(value)) for(var j = 0, valueLength = value.length; j < valueLength; ++j)buffer += this.renderTokens(token[4], context.push(value[j]), partials, originalTemplate, config);
        else if (typeof value === 'object' || typeof value === 'string' || typeof value === 'number') buffer += this.renderTokens(token[4], context.push(value), partials, originalTemplate, config);
        else if (isFunction(value)) {
            if (typeof originalTemplate !== 'string') throw new Error('Cannot use higher-order sections without the original template');
            // Extract the portion of the original template that the section contains.
            value = value.call(context.view, originalTemplate.slice(token[3], token[5]), subRender);
            if (value != null) buffer += value;
        } else buffer += this.renderTokens(token[4], context, partials, originalTemplate, config);
        return buffer;
    };
    Writer.prototype.renderInverted = function renderInverted(token, context, partials, originalTemplate, config) {
        var value = context.lookup(token[1]);
        // Use JavaScript's definition of falsy. Include empty arrays.
        // See https://github.com/janl/mustache.js/issues/186
        if (!value || isArray(value) && value.length === 0) return this.renderTokens(token[4], context, partials, originalTemplate, config);
    };
    Writer.prototype.indentPartial = function indentPartial(partial, indentation, lineHasNonSpace) {
        var filteredIndentation = indentation.replace(/[^ \t]/g, '');
        var partialByNl = partial.split('\n');
        for(var i = 0; i < partialByNl.length; i++)if (partialByNl[i].length && (i > 0 || !lineHasNonSpace)) partialByNl[i] = filteredIndentation + partialByNl[i];
        return partialByNl.join('\n');
    };
    Writer.prototype.renderPartial = function renderPartial(token, context, partials, config) {
        if (!partials) return;
        var tags = this.getConfigTags(config);
        var value = isFunction(partials) ? partials(token[1]) : partials[token[1]];
        if (value != null) {
            var lineHasNonSpace = token[6];
            var tagIndex = token[5];
            var indentation = token[4];
            var indentedValue = value;
            if (tagIndex == 0 && indentation) indentedValue = this.indentPartial(value, indentation, lineHasNonSpace);
            var tokens = this.parse(indentedValue, tags);
            return this.renderTokens(tokens, context, partials, indentedValue, config);
        }
    };
    Writer.prototype.unescapedValue = function unescapedValue(token, context) {
        var value = context.lookup(token[1]);
        if (value != null) return value;
    };
    Writer.prototype.escapedValue = function escapedValue(token, context, config) {
        var escape = this.getConfigEscape(config) || mustache.escape;
        var value = context.lookup(token[1]);
        if (value != null) return typeof value === 'number' && escape === mustache.escape ? String(value) : escape(value);
    };
    Writer.prototype.rawValue = function rawValue(token) {
        return token[1];
    };
    Writer.prototype.getConfigTags = function getConfigTags(config) {
        if (isArray(config)) return config;
        else if (config && typeof config === 'object') return config.tags;
        else return undefined;
    };
    Writer.prototype.getConfigEscape = function getConfigEscape(config) {
        if (config && typeof config === 'object' && !isArray(config)) return config.escape;
        else return undefined;
    };
    var mustache = {
        name: 'mustache.js',
        version: '4.2.0',
        tags: [
            '{{',
            '}}'
        ],
        clearCache: undefined,
        escape: undefined,
        parse: undefined,
        render: undefined,
        Scanner: undefined,
        Context: undefined,
        Writer: undefined,
        /**
     * Allows a user to override the default caching strategy, by providing an
     * object with set, get and clear methods. This can also be used to disable
     * the cache by setting it to the literal `undefined`.
     */ set templateCache (cache){
            defaultWriter.templateCache = cache;
        },
        /**
     * Gets the default or overridden caching object from the default writer.
     */ get templateCache () {
            return defaultWriter.templateCache;
        }
    };
    // All high-level mustache.* functions use this writer.
    var defaultWriter = new Writer();
    /**
   * Clears all cached templates in the default writer.
   */ mustache.clearCache = function clearCache() {
        return defaultWriter.clearCache();
    };
    /**
   * Parses and caches the given template in the default writer and returns the
   * array of tokens it contains. Doing this ahead of time avoids the need to
   * parse templates on the fly as they are rendered.
   */ mustache.parse = function parse(template, tags) {
        return defaultWriter.parse(template, tags);
    };
    /**
   * Renders the `template` with the given `view`, `partials`, and `config`
   * using the default writer.
   */ mustache.render = function render(template, view, partials, config) {
        if (typeof template !== 'string') throw new TypeError('Invalid template! Template should be a "string" but "' + typeStr(template) + '" was given as the first ' + 'argument for mustache#render(template, view, partials)');
        return defaultWriter.render(template, view, partials, config);
    };
    // Export the escaping function so that the user may override it.
    // See https://github.com/janl/mustache.js/issues/244
    mustache.escape = escapeHtml;
    // Export these mainly for testing, but also for advanced usage.
    mustache.Scanner = Scanner;
    mustache.Context = Context;
    mustache.Writer = Writer;
    return mustache;
});


var $ce9b58f7273ab9ef$var$E = Object.defineProperty, $ce9b58f7273ab9ef$var$_ = Object.defineProperties, $ce9b58f7273ab9ef$var$$ = Object.getOwnPropertyDescriptors, $ce9b58f7273ab9ef$var$m = Object.getOwnPropertySymbols, $ce9b58f7273ab9ef$var$P = Object.prototype.hasOwnProperty, $ce9b58f7273ab9ef$var$C = Object.prototype.propertyIsEnumerable, $ce9b58f7273ab9ef$var$p = (t, e, r)=>e in t ? $ce9b58f7273ab9ef$var$E(t, e, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : t[e] = r, $ce9b58f7273ab9ef$var$f = (t, e)=>{
    for(var r in e || (e = {}))$ce9b58f7273ab9ef$var$P.call(e, r) && $ce9b58f7273ab9ef$var$p(t, r, e[r]);
    if ($ce9b58f7273ab9ef$var$m) for (var r of $ce9b58f7273ab9ef$var$m(e))$ce9b58f7273ab9ef$var$C.call(e, r) && $ce9b58f7273ab9ef$var$p(t, r, e[r]);
    return t;
}, $ce9b58f7273ab9ef$var$G = (t, e)=>$ce9b58f7273ab9ef$var$_(t, $ce9b58f7273ab9ef$var$$(e));
const $ce9b58f7273ab9ef$var$y = (t = "always")=>({
        playMode: t,
        optimizeSeo: !0,
        createContainers: !0,
        hideOverflow: !1,
        timing: t === "always" ? {
            duration: 2000,
            iterations: 1 / 0
        } : {
            duration: 250,
            iterations: 1
        },
        glitchTimeSpan: t === "always" ? {
            start: .5,
            end: .7
        } : {
            start: 0,
            end: 1
        },
        shake: {
            velocity: 15,
            amplitudeX: .2,
            amplitudeY: .2
        },
        slice: t === "click" ? {
            count: 15,
            velocity: 20,
            minHeight: .02,
            maxHeight: .15,
            hueRotate: !0,
            cssFilters: ""
        } : {
            count: 6,
            velocity: 15,
            minHeight: .02,
            maxHeight: .15,
            hueRotate: !0,
            cssFilters: ""
        },
        pulse: !1
    }), $ce9b58f7273ab9ef$var$v = (t, e)=>{
    if (!t.glitchTimeSpan) return 1;
    const r = t.glitchTimeSpan.start, a = t.glitchTimeSpan.end;
    if (e < r || e > a) return 0;
    const n = r + (a - r) / 2;
    return e < n ? (e - r) / (n - r) : (a - e) / (a - n);
}, $ce9b58f7273ab9ef$var$u = (t, e)=>(Math.random() - .5) * 2 * $ce9b58f7273ab9ef$var$v(t, e), $ce9b58f7273ab9ef$var$b = ({ minHeight: t, maxHeight: e, minWidth: r, maxWidth: a })=>{
    const n = Math.floor(Math.random() * ((e - t) * 100 + 1)) + t * 100, s = Math.floor(Math.random() * ((a - r) * 100 + 1)) + r * 100, i = Math.floor(Math.random() * (100 - n)), l = Math.floor(Math.random() * (100 - s)), h = `${l + s}% ${i}%`, c = `${l + s}% ${i + n}%`, o = `${l}% ${i + n}%`, d = `${l}% ${i}%`;
    return `polygon(${h},${c},${o},${d})`;
}, $ce9b58f7273ab9ef$var$M = (t)=>{
    const e = Math.floor(t.slice.velocity * t.timing.duration / 1e3) + 1, r = [];
    for(let a = 0; a < e; ++a){
        if ($ce9b58f7273ab9ef$var$v(t, a / e) === 0) {
            r.push({
                opacity: "0",
                transform: "none",
                clipPath: "unset"
            });
            continue;
        }
        const s = {
            opacity: "1",
            transform: `translate3d(${$ce9b58f7273ab9ef$var$u(t, a / e) * 30}%,0,0)`,
            clipPath: $ce9b58f7273ab9ef$var$b({
                minHeight: t.slice.minHeight,
                maxHeight: t.slice.maxHeight,
                minWidth: 1,
                maxWidth: 1
            })
        };
        t.slice.cssFilters ? s.filter = t.slice.cssFilters : t.slice.hueRotate && (s.filter = `hue-rotate(${Math.floor($ce9b58f7273ab9ef$var$u(t, a / e) * 360)}deg)`), r.push(s);
    }
    return {
        steps: r,
        timing: $ce9b58f7273ab9ef$var$f({
            easing: `steps(${e},jump-start)`
        }, t.timing)
    };
}, $ce9b58f7273ab9ef$var$A = (t)=>t.pulse ? {
        steps: [
            {
                transform: "scale(1)",
                opacity: "1"
            },
            {
                transform: `scale(${t.pulse.scale})`,
                opacity: "0"
            }
        ],
        timing: $ce9b58f7273ab9ef$var$G($ce9b58f7273ab9ef$var$f({}, t.timing), {
            delay: (t.glitchTimeSpan ? t.glitchTimeSpan.start : 0) * t.timing.duration,
            easing: "ease-in-out"
        })
    } : null, $ce9b58f7273ab9ef$var$x = (t)=>{
    if (!t.shake) return {
        steps: [],
        timing: {}
    };
    const e = Math.floor(t.shake.velocity * t.timing.duration / 1e3) + 1, r = [];
    for(let a = 0; a < e; ++a){
        const n = $ce9b58f7273ab9ef$var$u(t, a / e) * t.shake.amplitudeX * 100, s = $ce9b58f7273ab9ef$var$u(t, a / e) * t.shake.amplitudeY * 100;
        r.push({
            transform: `translate3d(${n}%,${s}%,0)`
        });
    }
    return {
        steps: r,
        timing: $ce9b58f7273ab9ef$var$f({
            easing: `steps(${e},jump-start)`
        }, t.timing)
    };
}, $ce9b58f7273ab9ef$var$w = (t)=>[
        $ce9b58f7273ab9ef$var$x(t),
        $ce9b58f7273ab9ef$var$A(t),
        ...Array.from({
            length: t.slice.count
        }).map(()=>$ce9b58f7273ab9ef$var$M(t))
    ].filter((e)=>e !== null), $ce9b58f7273ab9ef$export$235b7fc70b9fc359 = (...t)=>{
    const e = (r)=>r && typeof r == "object";
    return t.reduce((r, a)=>(Object.keys(a).forEach((n)=>{
            e(r[n]) && e(a[n]) ? r[n] = $ce9b58f7273ab9ef$export$235b7fc70b9fc359(r[n], a[n]) : a[n] !== void 0 && (r[n] = a[n]);
        }), r), {});
}, $ce9b58f7273ab9ef$var$L = (t, e)=>{
    var r, a;
    if (!e.createContainers) return {
        container: t,
        layersContainer: t,
        glitched: t.firstElementChild
    };
    if (!t.dataset.glitched) {
        const i = document.createElement("div"), l = document.createElement("div");
        return getComputedStyle(t).getPropertyValue("display").match(/^inline/) && (l.style.display = "inline-block"), l.appendChild(i), (r = t.parentElement) == null || r.insertBefore(l, t), i.prepend(t), {
            container: l,
            layersContainer: i,
            glitched: t
        };
    }
    const n = t.parentElement, s = (a = t.parentElement) == null ? void 0 : a.parentElement;
    for(; n.children.length > 1;)n.removeChild(n.children[1]);
    return n.firstElementChild.getAnimations().forEach((i)=>i.cancel()), {
        container: s,
        layersContainer: n,
        glitched: t
    };
}, $ce9b58f7273ab9ef$var$O = (t, e, r)=>{
    const { glitched: a, container: n, layersContainer: s } = $ce9b58f7273ab9ef$var$L(t, r);
    s.style.display = "grid", r.hideOverflow && (n.style.overflow = "hidden"), r.html && (a.innerHTML = r.html), a.style.gridArea = "1/1/-1/-1";
    const i = a.cloneNode(!0);
    i.dataset.islayer = "true", i.style.gridArea = "1/1/-1/-1", i.style.userSelect = "none", i.style.pointerEvents = "none", i.style.opacity = "0";
    for(let c = 0; c < e.length - 1; ++c){
        const o = i.cloneNode(!0);
        s.appendChild(o);
    }
    const l = ()=>{
        e.forEach((c, o)=>{
            s.children[o].animate(c.steps, c.timing);
        });
    }, h = ()=>{
        e.forEach((c, o)=>{
            s.children[o].getAnimations().forEach((d)=>{
                d.cancel();
            });
        });
    };
    switch(n.onmouseenter = null, n.onmouseleave = null, n.onclick = null, r.playMode){
        case "always":
            l();
            break;
        case "hover":
            n.onmouseenter = l, n.onmouseleave = h;
            break;
        case "click":
            n.onclick = ()=>{
                h(), l();
            };
            break;
    }
    return t.dataset.glitched = "1", {
        container: n,
        startGlitch: l,
        stopGlitch: h
    };
}, $ce9b58f7273ab9ef$var$H = (t = ".powerglitch", e = {})=>{
    const r = $ce9b58f7273ab9ef$export$235b7fc70b9fc359($ce9b58f7273ab9ef$var$y(e.playMode), e);
    if (r.optimizeSeo && /google|bing|baidu|yandex|slurp|bot/i.exec(navigator.userAgent)) return {
        containers: [],
        startGlitch: ()=>{
            console.warn("PowerGlitch disabled");
        },
        stopGlitch: ()=>{
            console.warn("PowerGlitch disabled");
        }
    };
    let a = [];
    typeof t == "string" ? a = Array.from(document.querySelectorAll(t)) : t instanceof NodeList ? a = Array.from(t) : Array.isArray(t) ? a = t : t instanceof HTMLElement && (a = [
        t
    ]);
    const n = $ce9b58f7273ab9ef$var$w(r), s = a.filter((i)=>!i.dataset.islayer).map((i)=>$ce9b58f7273ab9ef$var$O(i, n, r));
    return {
        containers: s.map((i)=>i.container),
        startGlitch: ()=>s.forEach((i)=>i.startGlitch()),
        stopGlitch: ()=>s.forEach((i)=>i.stopGlitch())
    };
}, $ce9b58f7273ab9ef$export$b7c9073245f27197 = {
    glitch: $ce9b58f7273ab9ef$var$H,
    generateLayers: $ce9b58f7273ab9ef$var$w,
    getDefaultOptions: $ce9b58f7273ab9ef$var$y
};


var $5f465c1f0ebafd63$exports = {};
$5f465c1f0ebafd63$exports = "  [\n    {\n      \"text\": \"You're invited to a Parasite party! How do you feel?\",\n      \"answers\": [\n        {\n          \"text\": \"I'll check it out unless something more exciting comes up.\",\n          \"scores\": [\n            \"A\",\n            \"E\"\n          ]\n        },\n        {\n          \"text\": \"I love parties! I'm adding it to my calendar right away.\",\n          \"scores\": [\n            \"A\",\n            \"F\"\n          ]\n        },\n        {\n          \"text\": \"Not a big fan of parties but I'll see how I feel on the day!\",\n          \"scores\": [\n            \"B\",\n            \"E\"\n          ]\n        },\n        {\n          \"text\": \"My friends keep telling me I need to network more, so I guess I'll go...\",\n          \"scores\": [\n            \"B\",\n            \"F\"\n          ]\n        }\n      ]\n    },\n    {\n      \"text\": \"Tonight is the night! What are you going to wear?\",\n      \"answers\": [\n        {\n          \"text\": \"I want to turn heads! Something extravagant and loud!\",\n          \"scores\": [\n            \"A\"\n          ]\n        },\n        {\n          \"text\": \"I want to blend in - something sleek and effortlessly elegant.\",\n          \"scores\": [\n            \"B\"\n          ]\n        }\n      ]\n    },\n    {\n      \"text\": \"You arrive at the venue. What do you do first?\",\n      \"answers\": [\n        {\n          \"text\": \"I scan the room to see who might be interesting to talk to.\",\n          \"scores\": [\n            \"C\"\n          ]\n        },\n        {\n          \"text\": \"I check the food and drinks situation.\",\n          \"scores\": [\n            \"D\"\n          ]\n        }\n      ]\n    },\n    {\n      \"text\": \"The music is terrible. How do you fix this?\",\n      \"answers\": [\n        {\n          \"text\": \"I sidle up to the DJ and charm them into playing my favourite songs.\",\n          \"scores\": [\n            \"A\",\n            \"C\"\n          ]\n        },\n        {\n          \"text\": \"I badger the DJ with requests until they begrudgingly give in.\",\n          \"scores\": [\n            \"A\",\n            \"D\"\n          ]\n        },\n        {\n          \"text\": \"I find a way to hack into the audio system and stream music from my phone.\",\n          \"scores\": [\n            \"B\",\n            \"C\"\n          ]\n        },\n        {\n          \"text\": \"I fold my arms, look disgusted and ooze bad vibes to empty the dance floor.\",\n          \"scores\": [\n            \"B\",\n            \"D\"\n          ]\n        }\n      ]\n    },\n    {\n      \"text\": \"You overhear a delicious piece of gossip. What do you do?\",\n      \"answers\": [\n        {\n          \"text\": \"I immediately find a friend and spill the tea.\",\n          \"scores\": [\n            \"E\"\n          ]\n        },\n        {\n          \"text\": \"I hold on to it, maybe I can use this information to my advantage later.\",\n          \"scores\": [\n            \"F\"\n          ]\n        }\n      ]\n    },\n    {\n      \"text\": \"Someone interesting catches your eye. How do you approach them?\",\n      \"answers\": [\n        {\n          \"text\": \"I walk right up to them and introduce myself.\",\n          \"scores\": [\n            \"A\",\n            \"E\"\n          ]\n        },\n        {\n          \"text\": \"I stay close and impress them with my dance moves and dazzling charms until they cannot help but notice me.\",\n          \"scores\": [\n            \"A\",\n            \"F\"\n          ]\n        },\n        {\n          \"text\": \"I ask a mutual friend to engineer a casual interaction.\",\n          \"scores\": [\n            \"B\",\n            \"E\"\n          ]\n        },\n        {\n          \"text\": \"After the party I look up all their social media profiles and send them a perfectly crafted message.\",\n          \"scores\": [\n            \"B\",\n            \"F\"\n          ]\n        }\n      ]\n    },\n    {\n      \"text\": \"You are introduced to someone who is incredibly dull. What is your plan?\",\n      \"answers\": [\n        {\n          \"text\": \"I interrupt them mid-sentence and take over the entire conversation.\",\n          \"scores\": [\n            \"A\",\n            \"C\"\n          ]\n        },\n        {\n          \"text\": \"I bombard them with so many questions they get exhausted and go quiet.\",\n          \"scores\": [\n            \"A\",\n            \"D\"\n          ]\n        },\n        {\n          \"text\": \"I pretend that I got an urgent message on my phone and excuse myself.\",\n          \"scores\": [\n            \"B\",\n            \"C\"\n          ]\n        },\n        {\n          \"text\": \"I look so bored and only respond by hm-hming until they get the message and find another target.\",\n          \"scores\": [\n            \"B\",\n            \"D\"\n          ]\n        }\n      ]\n    },\n    {\n      \"text\": \"You spot your nemesis across the room, surrounded by a group of rapt listeners. How do you react?\",\n      \"answers\": [\n        {\n          \"text\": \"I cause a commotion that instantly draws all the attention away from them.\",\n          \"scores\": [\n            \"C\",\n            \"E\"\n          ]\n        },\n        {\n          \"text\": \"I start a nasty little rumour about them among the partygoers.\",\n          \"scores\": [\n            \"C\",\n            \"F\"\n          ]\n        },\n        {\n          \"text\": \"I walk over and 'accidentally' bump into them, spilling my drink all over them.\",\n          \"scores\": [\n            \"D\",\n            \"E\"\n          ]\n        },\n        {\n          \"text\": \"I keep hovering nearby to get under their skin.\",\n          \"scores\": [\n            \"D\",\n            \"F\"\n          ]\n        }\n      ]\n    },\n    {\n      \"text\": \"The party is winding down. Where are you?\",\n      \"answers\": [\n        {\n          \"text\": \"The night is still young! I'm rallying people to accompany me to the next gig.\",\n          \"scores\": [\n            \"C\",\n            \"E\"\n          ]\n        },\n        {\n          \"text\": \"I'm saying my goodbyes to everyone and making sure my new friends have my social media handles.\",\n          \"scores\": [\n            \"C\",\n            \"F\"\n          ]\n        },\n        {\n          \"text\": \"I ended the night on a high note and slipped out when I had enough.\",\n          \"scores\": [\n            \"D\",\n            \"E\"\n          ]\n        },\n        {\n          \"text\": \"I'm staying until the lights come on, savouring every last moment of the night.\",\n          \"scores\": [\n            \"D\",\n            \"F\"\n          ]\n        }\n      ]\n    }\n  ]";


var $f68491ad85d7a977$exports = {};
$f68491ad85d7a977$exports = "  [\n    {\n      \"scores\": [\n        \"A\",\n        \"C\",\n        \"E\"\n      ],\n      \"common\": \"Jewel Wasp\",\n      \"scientific\": \"Ampulex compressa\",\n      \"image\": \"wasp.png\",\n      \"emoji\": \"🦟\"\n    },\n    {\n      \"scores\": [\n        \"A\",\n        \"C\",\n        \"F\"\n      ],\n      \"common\": \"Green-Banded Broodsac\",\n      \"scientific\": \"Leucochloridium paradoxum\",\n      \"image\": \"broodsac.png\",\n      \"emoji\": \"🐌\"\n    },\n    {\n      \"scores\": [\n        \"A\",\n        \"D\",\n        \"E\"\n      ],\n      \"common\": \"Vampire Bat\",\n      \"scientific\": \"Desmodus rotundus\",\n      \"image\": \"bat.png\",\n      \"emoji\": \"🦇\"\n    },\n    {\n      \"scores\": [\n        \"A\",\n        \"D\",\n        \"F\"\n      ],\n      \"common\": \"Sea lamprey\",\n      \"scientific\": \"Petromyzon marinus\",\n      \"image\": \"lamprey.png\",\n      \"emoji\": \"\"\n    },\n    {\n      \"scores\": [\n        \"B\",\n        \"C\",\n        \"E\"\n      ],\n      \"common\": \"Horsehair worm\",\n      \"scientific\": \"Spinochordodes tellinii\",\n      \"image\": \"worm.png\",\n      \"emoji\": \"🪱\"\n    },\n    {\n      \"scores\": [\n        \"B\",\n        \"C\",\n        \"F\"\n      ],\n      \"common\": \"Toxoplasmosis parasite\",\n      \"scientific\": \"Toxoplasma gondii\",\n      \"image\": \"toxoplasma.png\",\n      \"emoji\": \"🐈‍⬛\"\n    },\n    {\n      \"scores\": [\n        \"B\",\n        \"D\",\n        \"E\"\n      ],\n      \"common\": \"Brain-Eating Amoeba\",\n      \"scientific\": \"Naegleria fowleri\",\n      \"image\": \"amoeba.png\",\n      \"emoji\": \"🧠\"\n    },\n    {\n      \"scores\": [\n        \"B\",\n        \"D\",\n        \"F\"\n      ],\n      \"common\": \"Tongue-Eating Louse\",\n      \"scientific\": \"Cymothoa exigua\",\n      \"image\": \"louse.png\",\n      \"emoji\": \"👅\"\n    }\n  ]";


var $39794ca8c3e82f5f$exports = {};
$39794ca8c3e82f5f$exports = import.meta.resolve("W43Jl");


var $b23b0a392152f3ce$exports = {};
$b23b0a392152f3ce$exports = import.meta.resolve("gEBD2");


"use strict";
const $54b47fc030b7b21e$export$aa473411bddb7e17 = JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($5f465c1f0ebafd63$exports))));
const $54b47fc030b7b21e$export$190fdd7c86e5a6c7 = JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($f68491ad85d7a977$exports))));
let $54b47fc030b7b21e$var$questionTemplate;
let $54b47fc030b7b21e$var$currentQuestion = 0;
let $54b47fc030b7b21e$var$scores = {
    A: 0,
    B: 0,
    C: 0,
    D: 0,
    E: 0,
    F: 0
};
const $54b47fc030b7b21e$var$delay = (ms)=>new Promise((res)=>setTimeout(res, ms));
function $54b47fc030b7b21e$var$updateProgress(current, total) {
    let progressBar = document.getElementById("progress");
    let progressValue = document.getElementById("progressvalue");
    progressBar.dataset.label = "Question " + (current + 1) + " of " + total;
    progressValue.style.width = current / total * 100 + "%";
}
function $54b47fc030b7b21e$var$showQuestion() {
    let question = $54b47fc030b7b21e$export$aa473411bddb7e17[$54b47fc030b7b21e$var$currentQuestion];
    let questionText = document.getElementById("question");
    let answers = document.getElementById("answers");
    // Show question   
    $54b47fc030b7b21e$var$updateProgress($54b47fc030b7b21e$var$currentQuestion, $54b47fc030b7b21e$export$aa473411bddb7e17.length);
    (0, $ce9b58f7273ab9ef$export$b7c9073245f27197).glitch(questionText, {
        "html": question.text,
        "timing": {
            "duration": 250,
            "iterations": 1
        },
        "glitchTimeSpan": {
            "start": 0,
            "end": 1
        },
        "slice": {
            "count": 15,
            "velocity": 20
        }
    });
    // Shuffle answers
    question.answers = question.answers.map((value)=>({
            value: value,
            sort: Math.random()
        })).sort((a, b)=>a.sort - b.sort).map(({ value: value })=>value);
    // Show answers
    answers.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render($54b47fc030b7b21e$var$questionTemplate, {
        answers: question.answers
    });
    let currentAnswer = 0;
    Array.from(answers.getElementsByTagName("button")).forEach((button)=>{
        let answerNumber = currentAnswer;
        button.onclick = ()=>{
            $54b47fc030b7b21e$export$aa473411bddb7e17[$54b47fc030b7b21e$var$currentQuestion].answers[answerNumber].scores.forEach((score)=>$54b47fc030b7b21e$var$scores[score] += 1);
            $54b47fc030b7b21e$var$currentQuestion++;
            if ($54b47fc030b7b21e$var$currentQuestion >= $54b47fc030b7b21e$export$aa473411bddb7e17.length) {
                const audio = new Audio((0, (/*@__PURE__*/$parcel$interopDefault($b23b0a392152f3ce$exports))));
                audio.currentTime = 0;
                audio.play();
                $54b47fc030b7b21e$var$showResult();
            } else {
                const audio = new Audio((0, (/*@__PURE__*/$parcel$interopDefault($39794ca8c3e82f5f$exports))));
                audio.currentTime = 0;
                audio.play();
                $54b47fc030b7b21e$var$showQuestion();
            }
        };
        currentAnswer++;
    });
}
function $54b47fc030b7b21e$var$showResult() {
    let questionText = document.getElementById("question");
    let answers = document.getElementById("answers");
    let progressBar = document.getElementById("progress");
    progressBar.style.display = "none";
    // Animate loading
    answers.style.display = "none";
    (0, $ce9b58f7273ab9ef$export$b7c9073245f27197).glitch(questionText, {
        "html": "Analyzing...",
        "timing": {
            "duration": 500,
            "iterations": 1
        },
        "glitchTimeSpan": {
            "start": 0,
            "end": 1
        },
        "slice": {
            "count": 15,
            "velocity": 20
        }
    });
    const showResult = async ()=>{
        await $54b47fc030b7b21e$var$delay(1000);
        questionText.innerHTML = "The results are in!";
        answers.style.display = "block";
        let bestResult = null;
        let bestScore = 0;
        $54b47fc030b7b21e$export$190fdd7c86e5a6c7.forEach((result)=>{
            let currentScore = result.scores.reduce((accumulator, currentValue)=>accumulator + $54b47fc030b7b21e$var$scores[currentValue], 0);
            if (currentScore >= bestScore) {
                bestScore = currentScore;
                bestResult = result;
            }
        });
        console.log($54b47fc030b7b21e$var$scores);
        console.log(bestResult);
        // Show answers
        let resultTemplate = document.getElementById("resultTemplate").innerHTML;
        answers.innerHTML = (0, (/*@__PURE__*/$parcel$interopDefault($d486cd8337e91fbc$exports))).render(resultTemplate, bestResult);
        window.addEventListener('blur', ()=>{
            setTimeout(()=>{
                if (document.activeElement.tagName === 'IFRAME') umami.track('Spotify'); // eslint-disable-line no-undef
            });
        }, {
            once: true
        });
    };
    showResult();
}
document.addEventListener("DOMContentLoaded", function() {
    $54b47fc030b7b21e$var$questionTemplate = document.getElementById("questionTemplate").innerHTML;
    document.getElementById("envelope").addEventListener("click", function() {
        $54b47fc030b7b21e$var$showQuestion();
        document.getElementById("progress").style.visibility = "visible";
    });
});


//# sourceMappingURL=views.dac34103.js.map
